import api from './api';

const getReferral = async () => {
  const response = await api({
    method: 'GET',
    url: '/referral',
  });

  return response;
};

const registerReferral = async () => {
  const response = await api({
    method: 'POST',
    url: '/referral',
  });

  return response;
};

const checkUserEligibility = async () => {
  const response = await api({
    method: 'GET',
    url: '/referral/eligibility',
  });

  return response;
};

const applyReferral = async (referralCode) => {
  const response = await api({
    method: 'POST',
    url: '/referral/apply',
    data: {
      referralCode,
    },
  });

  return response;
};

const redeemReferral = async (points) => {
  const response = await api({
    method: 'POST',
    url: '/referral/redeem',
    data: {
      points,
    },
  });

  return response;
};

const changeReferralCode = async (referralCode) => {
  const response = await api({
    method: 'PUT',
    url: '/referral',
    data: {
      referralCode,
    },
  });

  return response;
};

export {
  getReferral,
  registerReferral,
  applyReferral,
  redeemReferral,
  checkUserEligibility,
  changeReferralCode,
};
